module.exports = __webpack_public_path__ + "static/media/27.1d8fcaa5.jpg";